import { render } from "./QuestionAnswer.vue?vue&type=template&id=abc26124&scoped=true&ts=true"
import script from "./QuestionAnswer.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswer.vue?vue&type=script&lang=ts"

import "./QuestionAnswer.vue?vue&type=style&index=0&id=abc26124&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc26124"]])

export default __exports__